
import React from "react";
import { HolidayCampaignList } from "@/components/communications/HolidayCampaignList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent } from "@/components/ui/card";

export default function HolidayCampaigns() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-2xl font-bold">Holiday Communication Plans</h1>
      <p className="text-muted-foreground">
        Manage holiday campaigns, cards, and gift planning for clients
      </p>

      <Tabs defaultValue="campaigns" className="w-full">
        <TabsList>
          <TabsTrigger value="campaigns">Campaigns</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        <TabsContent value="campaigns" className="space-y-4 mt-4">
          <Card>
            <CardContent className="pt-6">
              <HolidayCampaignList />
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="analytics" className="space-y-4 mt-4">
          <Card>
            <CardContent className="pt-6">
              <h2 className="text-xl font-semibold">Campaign Analytics</h2>
              <p className="text-muted-foreground mt-2">
                Holiday campaign performance and engagement metrics will be shown here.
              </p>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
